var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67285 6.88647H0.409668V20.659H4.67285V6.88647Z",
    fill: "#535F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52083 5.08312C3.02436 5.08724 3.51775 4.94171 3.93844 4.66497C4.35912 4.38823 4.68811 3.99275 4.88369 3.52874C5.07926 3.06472 5.13259 2.55308 5.03692 2.05871C4.94124 1.56433 4.70087 1.10952 4.3463 0.751973C3.99174 0.394424 3.53895 0.150246 3.0454 0.0504347C2.55185 -0.0493763 2.03978 -0.000345513 1.57415 0.191334C1.10851 0.383014 0.710297 0.708684 0.430043 1.12703C0.14979 1.54538 0.000116382 2.03758 2.02707e-05 2.54113C-0.00266418 3.21246 0.261376 3.85738 0.73409 4.33406C1.2068 4.81075 1.8495 5.08018 2.52083 5.08312Z",
    fill: "#535F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4876 13.4297C11.4876 11.4936 12.3786 10.3397 14.0851 10.3397C15.6526 10.3397 16.4059 11.4469 16.4059 13.4297V20.6597H20.6494V11.9397C20.6494 8.2507 18.5584 6.46701 15.6385 6.46701C14.809 6.45551 13.9907 6.65906 13.2633 7.05787C12.536 7.45667 11.9243 8.03712 11.4879 8.74262V6.88739H7.39795V20.6599H11.4879L11.4876 13.4297Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.16ff907eb778cc8e7f16e35a543b242c.svg";
export { ForwardRef as ReactComponent };